<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>User Plans</h2>
        <div class="d-flex flex-wrap justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="openSearch">Search</a>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <div class="items-per-page-dropdown mb-3">
            <label>Items Per Page: </label>
            <select v-model="size" @change="updateItemsPerPage">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('userPlanId')">User Plan Id</th>
              <th class="col-1" @click="toggleSort('userId')">User Id</th>
              <th class="col-1" @click="toggleSort('planId')">Plan Id</th>
              <th class="col-1" @click="toggleSort('couponCode')">Coupon Code</th>
              <th class="col-1" @click="toggleSort('startDate')">Start Date</th>
              <th class="col-1" @click="toggleSort('endDate')">End Date</th>
              <th class="col-1" @click="toggleSort('trialActivationCode')">Trial Activation Code</th>
              <th class="col-1" @click="toggleSort('stripeInvoice')">Stripe Invoice</th>
              <th class="col-1" @click="toggleSort('stripeConfigurationId')">Stripe Configuration Id</th>
              <th class="col-1" @click="toggleSort('paypalConfigurationId')">Paypal Configuration Id</th>
              <th class="col-1" @click="toggleSort('paypalOrderId')">Paypal Order Id</th>
              <th class="col-1" @click="toggleSort('paypalCaptureId')">Paypal Capture Id</th>
              <th class="col-1" @click="toggleSort('plisioConfigurationId')">Plisio Configuration Id</th>
              <th class="col-1" @click="toggleSort('plisioTxnId')">Plisio Txn Id</th>
              <th class="col-1" @click="toggleSort('squareConfigurationId')">Square Configuration Id</th>
              <th class="col-1" @click="toggleSort('squareOrderId')">Square Order Id</th>
              <th class="col-1" @click="toggleSort('cpayPayment')">CPay Payment</th>
              <th class="col-1" @click="toggleSort('stripePaidAmount')">Stripe Paid Amount</th>
              <th class="col-1" @click="toggleSort('stripePaymentDate')">Stripe Payment Date</th>
              <th @click="toggleSort('status')">Status</th>
              <th @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('created')">Created</th>
              <th class="col-1" @click="toggleSort('updated')">Updated</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.userPlanId">
              <td class="col-1 text-truncate" v-html="truncateText(config.userPlanId, 50)"  @click="selectText" :data-text="config.userPlanId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.userId, 30)"  @click="selectText" :data-text="config.userId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.planId, 30)" :title="config.planId" @click="selectText" :data-text="config.planId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.couponCode, 30)" @click="selectText" :data-text="config.couponCode"></td>
              <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.startDate)" :title="formatUnixTimestamp(config.startDate)" @click="selectText" :data-text="config.startDate"></td>
              <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.endDate)" :title="formatUnixTimestamp(config.endDate)" @click="selectText" :data-text="config.endDate"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.trialActivationCode, 30)" @click="selectText" :data-text="config.trialActivationCode"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeInvoice, 30)" @click="selectText" :data-text="config.stripeInvoice"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeConfigurationId, 30)" @click="selectText" :data-text="config.stripeConfigurationId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.paypalConfigurationId, 30)" @click="selectText" :data-text="config.paypalConfigurationId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.paypalOrderId, 30)" @click="selectText" :data-text="config.paypalOrderId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.paypalCaptureId, 30)" @click="selectText" :data-text="config.paypalCaptureId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.plisioConfigurationId, 30)" @click="selectText" :data-text="config.plisioConfigurationId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.plisioTxnId, 30)" @click="selectText" :data-text="config.plisioTxnId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.squareConfigurationId, 30)" @click="selectText" :data-text="config.squareConfigurationId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.squareOrderId, 30)" @click="selectText" :data-text="config.squareOrderId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.cpayPayment, 10)" @click="selectText" :data-text="config.cpayPayment"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripePaidAmount, 30)" @click="selectText" :data-text="config.stripePaidAmount"></td>
              <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.stripePaymentDate)" :title="formatUnixTimestamp(config.stripePaymentDate)" @click="selectText" :data-text="config.stripePaymentDate"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.status, 10)" @click="selectText" :data-text="config.status"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 10)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.created)" :title="formatUnixTimestamp(config.created)" @click="selectText" :data-text="config.created"></td>
              <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.updated)" :title="formatUnixTimestamp(config.updated)" @click="selectText" :data-text="config.updated"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'UserPlanEdit', params: { id: config.userPlanId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
        <vue-awesome-paginate
            :total-items="totalElements"
            :items-per-page="size"
            :max-pages-shown="5"
            v-model="page"
            :on-click="changePage"
        />
      </div>
    </div>
    <!-- Modal -->
    <div class="modal d-block" v-if="showSearch">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">Search in users</h4>
            <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="closeSearch">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form">
              <label>User Plan Id</label>
              <input type="text" v-model="searchFilters.userPlanId">
              <label>User id</label>
              <input type="text" v-model="searchFilters.userId">
              <label>User Email</label>
              <input type="text" v-model="searchFilters.email">
              <label >Plan Id</label>
              <input type="text" v-model="searchFilters.planId">
              <label>Coupon code</label>
              <input type="text" v-model="searchFilters.couponCode">
              <label>Start Date</label>
              <input type="text" v-model="searchFilters.startDate">
              <label >End Date</label>
              <input type="text" v-model="searchFilters.endDate">
              <label>Trial Activation Code</label>
              <input type="text" v-model="searchFilters.trialActivationCode">
              <label >Stripe Invoice</label>
              <input type="text" v-model="searchFilters.stripeInvoice">
              <label>Stripe Configuration Id</label>
              <input type="text" v-model="searchFilters.stripeConfigurationId">
              <label>Paypal Configuration Id</label>
              <input type="text" v-model="searchFilters.paypalConfigurationId">
              <label>Paypal Order Id</label>
              <input type="text" v-model="searchFilters.paypalOrderId">
              <label>Paypal Capture Id</label>
              <input type="text" v-model="searchFilters.paypalCaptureId">
              <label>Plisio Configuration Id</label>
              <input type="text" v-model="searchFilters.plisioConfigurationId">
              <label>Plisio Txn Id</label>
              <input type="text" v-model="searchFilters.plisioTxnId">
              <label>Square Configuration Id</label>
              <input type="text" v-model="searchFilters.squareConfigurationId">
              <label>Square Order Id</label>
              <input type="text" v-model="searchFilters.squareOrderId">
              <label>CPay Payment</label>
              <div style="display: flex; align-items: center; gap: 6px;">
                <input class="checkbox" type="checkbox" v-model="searchFilters.cpayPayment">
                <span v-if="searchFilters.cpayPayment === null" style="color: gray; font-size: 0.85em;">Null</span>
              </div>
              <label >Stripe Paid Amount</label>
              <input type="text" v-model="searchFilters.stripePaidAmount">
              <label >Stripe Payment Date</label>
              <input type="text" v-model="searchFilters.stripePaymentDate">
              <label>Active</label>
              <div style="display: flex; align-items: center; gap: 6px;">
                <input class="checkbox" type="checkbox" v-model="searchFilters.active">
                <span v-if="searchFilters.active === null" style="color: gray; font-size: 0.85em;">Null</span>
              </div>
              <label >Status</label>
              <div style="display: flex; align-items: center; gap: 6px;">
                <input class="checkbox" type="checkbox" v-model="searchFilters.status">
                <span v-if="searchFilters.status === null" style="color: gray; font-size: 0.85em;">Null</span>
              </div>
              <label>Created</label>
              <input type="text" v-model="searchFilters.created">
              <label>Updated</label>
              <input type="text" v-model="searchFilters.updated">
            </form>
            <div v-if="errorMessage !== ''" class="error-message">{{errorMessage}}</div>
          </div>
          <div class="modal-footer">
            <a class="btn cancel-btn" role="button" data-dismiss="modal" @click="closeSearch">Cancel</a>
            <a class="btn signout-popup text-white" role="button" @click="doLoadData">Search</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import {UserPlanRequest, Sort, UserPlanFilter} from "@/model/models";
import {formatUnixTimestamp, truncateText, wrapText} from "@/utils/general-functions"
import Cookies from "js-cookie";

export default {
  name: "UserPlans",
  components: {
    Header,
  },
  data() {
    return {
      showSearch: false,
      page: 1,
      size: 20,
      totalElements: 0,
      UserPlanList: [],
      sortColumn: null,
      sortDirection: "ASC",
      errorMessage: null,
      selectedApp: '',
      searchFilters: new UserPlanFilter(null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null),

    };
  },
  computed: {
    sortData() {
      return this.UserPlanList;
    },
  },
  created() {
    const appCookie = Cookies.get('application');
    if (appCookie) {
      this.selectedApp = appCookie;
    }
    this.doLoadData();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));
  },
  methods: {
    truncateText,
    wrapText,
    formatUnixTimestamp,
    changePage(page) {
      this.page = page
      this.doLoadData()
    },
    doLoadData() {
      let request = new UserPlanRequest(
          this.page - 1,
          this.size
      );
      if (this.sortColumn != null) {
        request.sort = new Sort(this.sortColumn, this.sortDirection);
      }
      if (this.selectedApp !== '') {
        request.application = this.selectedApp;
      }
      request.filter = new UserPlanFilter(
          this.searchFilters.userPlanId, this.searchFilters.userId, this.searchFilters.email, this.searchFilters.planId, this.searchFilters.couponCode,
          this.searchFilters.startDate, this.searchFilters.endDate, this.searchFilters.trialActivationCode, this.searchFilters.stripeInvoice,
          this.searchFilters.stripeConfigurationId, this.searchFilters.paypalConfigurationId, this.searchFilters.paypalOrderId, this.searchFilters.paypalCaptureId,
          this.searchFilters.plisioConfigurationId, this.searchFilters.plisioTxnId, this.searchFilters.squareConfigurationId, this.searchFilters.squareOrderId,
          this.searchFilters.cpayPayment, this.searchFilters.stripePaidAmount, this.searchFilters.stripePaymentDate,
          this.searchFilters.active, this.searchFilters.status, this.searchFilters.created, this.searchFilters.updated
      );

      AdminService.getUserPlanList(request).then((data) => {
        this.closeSearch()
        this.UserPlanList = data.userPlanList;
        this.page = data.page + 1
        this.totalElements = data.totalElements
        this.searchFilters = new UserPlanFilter(
            data.filter.userPlanId, data.filter.userId, data.filter.email, data.filter.planId, data.filter.startDate, data.filter.endDate,
            data.filter.trialActivationCode, data.filter.stripeInvoice,  data.filter.stripeConfigurationId, data.filter.paypalConfigurationId,
            data.filter.stripePaidAmount, data.filter.stripePaymentDate, data.filter.status, data.filter.active
        );
      }).catch((error) => {
        if (error.response) {
          this.errorMessage = error.response.data.message;
        }
        console.log(error)
      });
    },
    closeSearch() {
      this.searchFilters = new UserPlanFilter(null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null, null)

      this.showSearch = false
      this.errorMessage = null
    },
    openSearch() {
      this.searchFilters = new UserPlanFilter(null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null, null)

      this.page = 1
      this.showSearch = true
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      await navigator.clipboard.writeText(originalText);
      this.highlightElement(event.target);
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'ASC';
      }
      this.doLoadData()
    },
    updateItemsPerPage() {
      this.doLoadData()
    },
    redirectToCreate() {
      this.$router.push({ name: 'UserPlanCreate' });
    },
  },
  mounted() {
    window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.showSearch) {
        this.closeSearch();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('keyup', this.closeSearch);
  }
};
</script>
<style src="../../assets/style.css">
</style>
